/**
 * WritersDashboardApp_v2 Definition
 * App metadata for the Writers Dashboard application
 */

import { AppDefinition } from '../../types/apps';

export const WritersDashboardAppDefinition: AppDefinition = {
  appId: 'writers_dashboard',
  name: 'Writing Hub',
  version: '1.0.0',
  description: 'Organize your self-publishing journey with goal tracking, workflow management, and AI-powered writing tools.',
  longDescription: `A comprehensive dashboard designed for self-published authors to manage their entire writing process from brainstorming to publishing.

**Key Features:**
- **Goal Tracking**: Set word count goals, daily targets, and completion dates
- **Writing Workflow**: Step-by-step checklist for the entire writing process
- **AI-Powered Tools**: Integrated AI assistance for each stage of writing
- **Progress Metrics**: Visual tracking of your writing progress
- **Persistent**: All your settings and progress auto-save in real-time

Perfect for authors who want to stay organized and motivated throughout their writing journey.`,
  icon: {
    type: 'phosphor',
    phosphorIcon: 'BookOpen',
    phosphorWeight: 'duotone',
    color: '#8b5cf6',
  },
  
  creator: {
    name: 'River',
    verified: true
  },
  
  categories: ['Productivity', 'Writing'],
  tags: ['writing', 'authors', 'self-publishing', 'dashboard', 'goals', 'workflow'],
  releaseDate: new Date().toISOString(),
  lastUpdated: new Date().toISOString(),
  
  entityTypes: ['WritersDashboard'],
  component: 'WritersDashboardApp_v2',
  requiresEntity: true,
  requiresProps: false,
  
  // Keyboard shortcuts
  hotkeys: {
    'cmd+s': 'save',
    'escape': 'closeModal'
  },
  
  // AI tool integration
  agenticToolIds: [
    'writers_brainstorm',
    'writers_outline',
    'writers_first_draft',
    'writers_characters',
    'writers_plot',
    'writers_revision',
    'writers_editing',
    'writers_proofread',
    'writers_cover_design',
    'writers_publish_prep'
  ],
  
  // Actions for command palette
  actions: {
    configure: {
      name: 'Configure Dashboard',
      description: 'Set your writing goals and targets',
      parameters: {}
    },
    updateMetrics: {
      name: 'Update Word Count',
      description: 'Manually update your word count',
      parameters: {
        wordCount: { type: 'number', required: true }
      }
    }
  },

  experimental: true,
};

export default WritersDashboardAppDefinition;
